"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextareaFieldStyles = void 0;
var core_1 = require("@material-ui/core");
var commons_1 = require("../../../style/commons");
exports.useTextareaFieldStyles = (0, core_1.makeStyles)(function () { return ({
    inputLabel: {
        position: 'relative',
        transform: 'translate(0,0)',
        color: commons_1.darkSecondary,
        fontSize: 14,
        fontWeight: 400,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        marginBottom: 4,
        '&$inputLabelShrink': {
            transform: 'translate(0,0) scale(1)',
        },
        '&$inputLabelFocused': {
            color: commons_1.darkSecondary,
        },
        '&$inputLabelDisabled': {
            color: commons_1.mediumLightBlue,
        },
    },
    inputLabelShrink: {},
    inputLabelFocused: {},
    inputLabelDisabled: {},
    inputBase: {
        height: 'auto',
        padding: 0,
        outline: "1px solid ".concat(commons_1.brandPrimaryLight),
        '&$inputBaseFocused': {
            outline: "2px solid ".concat(commons_1.brandPrimaryExtraDark, " !important"),
            backgroundColor: commons_1.lightSecondary,
            '&:hover': {
                outline: "2px solid ".concat(commons_1.brandPrimaryExtraDark),
            },
        },
    },
    inputBaseFocused: {
        outline: "2px solid ".concat(commons_1.brandPrimaryExtraDark, " !important"),
    },
    inputBaseError: {
        '& > textarea': {
            borderColor: commons_1.mediumRed,
        },
    },
    input: {
        color: commons_1.darkSecondary,
        fontSize: 16,
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        borderRadius: 4,
        backgroundColor: commons_1.secondaryHover,
        height: 89,
        fontWeight: 400,
        lineHeight: 'normal',
        padding: '8px 12px',
        '&::placeholder': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            color: commons_1.textInputColor,
            opacity: 1,
        },
        '&:-ms-input-placeholder': {
            fontStyle: 'normal',
            color: commons_1.textInputColor,
            opacity: 1,
        },
        '& + fieldset': {
            display: 'none',
        },
        '&:focus': {
            borderColor: commons_1.brandPrimaryExtraDark,
            backgroundColor: commons_1.lightSecondary,
        },
        '&:disabled': {
            opacity: 0.4,
        },
        '&:hover': {
            borderColor: commons_1.primaryColor,
        },
    },
}); });
